import { useEffect, useMemo, useCallback } from 'react'

import { ReduxState, setCalcul } from '@batical/reducer/src'
import { removeCalculLink, selectCalculLink } from '@batical/reducer/src/navigation'
import { CalculCodeStateKeys } from '@batical/types/src'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'

export function useIsFocusedCalculLink(calculCode: CalculCodeStateKeys, navCalculCode?: CalculCodeStateKeys, onBack?: () => void) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const selectCalMemo = useMemo(selectCalculLink, [])
  const ss = useSelector((state: ReduxState) => selectCalMemo(state, location.key))

  useEffect(() => {
    //   console.log(location)
    if (ss && ss.fromCalculCode === calculCode && ss.toCalculCode === navCalculCode) {
      dispatch(setCalcul(calculCode))
      if (onBack) {
        onBack()
        dispatch(removeCalculLink(location.key))
      }
    }
    if (navCalculCode && onBack) {
      // const navState = navigation.dangerouslyGetState()
      // if (isFocused) {
      //   if (navIndex.current === -1) {
      //     navIndex.current = Number(navState.index)
      //   } else if (navIndex.current === navState.index && nextScreen.current === navCalculCode) {
      //     dispatch(setCalcul(calculCode))
      //     onBack()
      //     nextScreen.current = ''
      //   }
      // } else {
      //   if (navState.index > navIndex.current) {
      //     nextScreen.current = navState.routes[navState.index].name
      //   }
      // }
    }
  }, [calculCode, dispatch, location, navCalculCode, navigate, onBack, ss])

  const nav = useCallback(() => {
    if (navCalculCode) {
      dispatch(setCalcul(navCalculCode))
      navigate(`/dashboard/${navCalculCode}`, { state: { fromKey: location.key, fromCalculCode: calculCode } })
    }
  }, [calculCode, dispatch, location.key, navCalculCode, navigate])

  return nav
}

export function useProjectFocusedCalcul(_projectCode: string, _onBack?: (_val: string) => void) {
  return true
}
